"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _placeholder = _interopRequireDefault(require("./assets/placeholder.svg"));

var _Button = _interopRequireDefault(require("@eig-builder/core-ui/Button"));

var _Grid = _interopRequireDefault(require("@eig-builder/core-ui/Grid"));

var _Paper = _interopRequireDefault(require("@eig-builder/core-ui/Paper"));

var _Typography = _interopRequireDefault(require("@eig-builder/core-ui/Typography"));

var _styles = require("@eig-builder/core-ui/styles");

var _taggingHelper = require("@eig-builder/core-utils/helpers/tagging-helper");

require("./lang");

var _moduleLocalization = _interopRequireDefault(require("@eig-builder/module-localization"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  padding: ", "px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    wrapper: {
      display: 'flex',
      height: 'calc(100%)'
    },
    centered: {
      margin: 'auto'
    },
    icon: {
      fontSize: 50
    },
    text: {
      margin: theme.spacing(1, 0)
    }
  };
});
var Container = (0, _styledComponents.default)(_Grid.default)(_templateObject(), function (props) {
  return props.theme.spacing(4);
});
/**
 * Component that can be used as a fallback for when an error occurs.
 */

var Error = function Error(_ref) {
  var onClick = _ref.onClick,
      image = _ref.image,
      errorMessage = _ref.errorMessage,
      buttonText = _ref.buttonText;
  var classes = useStyles();
  return _react.default.createElement("div", {
    className: "pt-5 ".concat(classes.wrapper)
  }, _react.default.createElement("div", {
    className: "col-6 ".concat(classes.centered)
  }, _react.default.createElement(_Paper.default, null, _react.default.createElement(Container, {
    container: true,
    direction: "column",
    justify: "center",
    alignItems: "center",
    spacing: 4
  }, _react.default.createElement(_Grid.default, {
    item: true
  }, _react.default.createElement("img", {
    src: image
  })), _react.default.createElement(_Grid.default, {
    item: true
  }, _react.default.createElement(_Typography.default, {
    variant: "h4"
  }, errorMessage)), _react.default.createElement(_Grid.default, {
    item: true
  }, _react.default.createElement(_Button.default, {
    dataElementLocation: _taggingHelper.DataElementLocations.BODY,
    dataElementId: "compositions.core--error--go-back-button",
    dataElementLabel: "compositions.core--error--go-back-button",
    onClick: onClick,
    className: "mt-2"
  }, buttonText))))));
};

Error.propTypes = {
  image: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.string]),
  errorMessage: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.element, _propTypes.default.string]),
  buttonText: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.element, _propTypes.default.string]),
  onClick: _propTypes.default.func.isRequired
};
Error.defaultProps = {
  image: _placeholder.default,
  errorMessage: _react.default.createElement(_moduleLocalization.default, {
    message: "compositions.core.error.defaultMessage"
  }),
  buttonText: _react.default.createElement(_moduleLocalization.default, {
    message: "compositions.core.error.goBackButton"
  })
};

var _default = (0, _react.memo)(Error);

exports.default = _default;